var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.tooltip,"placement":"top","open-delay":150}},[_c('span',{staticClass:"form-control-plaintext wr-figure"},[(_vm.prefix)?_c('span',[_vm._v(_vm._s(_vm.prefix))]):_vm._e(),_vm._v(_vm._s(_vm.formatted)+" "),_c('i',{staticClass:"fas fa-info-circle wr-figure-icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }